import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants"

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']
export const DISASTERMONITOR_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        'District Boundary': {
            source: 'INDIA',
            displayName: 'District',
            name: 'District Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Boundary',
            layeroptions_pane: 'district',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'DISASTER_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'Block Boundary': {
            source: 'INDIA',
            displayName: 'Block',
            name: 'Block Boundary',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
            layer_name: 'Block Boundary',
            layeroptions_pane: 'state',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'DISASTER_LEGEND',
            layeroptions_protocol: 'WFS'
        },
    }
}

export const DISASTER_LOCATION: any = [
    { name: "Bihar", coords: [25.9644, 85.2722] },
    { name: "Maharastra", coords: [19.7515, 75.7139] },
    { name: "Madhya Pradesh", coords: [22.9734, 78.6569] },
    { name: "French Wiki District entry", coords: [30.0668, 79.0193] },
    { name: "Telangana", coords: [17.123184, 79.208824] },
    { name: "Kerala", coords: [10.850516, 76.271080] },
    { name: "Karnataka", coords: [15.317277, 75.713890] },
    { name: "Himachal Pradesh", coords: [32.084206, 77.571167] },
    {name : "Assam", coords: [26.2006043, 92.9375739]}
]

export const DisasterTableConfiguration = {
    tableInfo: {
        type: 'dataTable',
        title: {
            display: true,
            text: '',
            align: 'center', // where to align the element within div i.e left, center or right
            order: 'order-md-2' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
        },
    },
    css: {
        tableClass: 'table table-striped table-bordered m-0',
        theadClass: '',
        tbodyClass: ''
    },
    // sortOptions: {
    //     sortIndex: 0,
    //     sortType: 'desc'
    // },
    searchFilter: {
        display: true,
        align: 'left', // where to align the element within div i.e left, center or right
        order: 'order-md-1' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    breadcrumbCons: {
        show: true,
        queryparams: []
    },
    downloadButton: {
        
        display: true,
        text: 'Download',
        align: 'right', // where to align the element within div i.e left, center or right
        order: 'order-md-3' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    downloadOptions: [
        {
            downloadType: 'xlsx',
            downloadFileName: 'Disaster Monitoing',
            downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
            metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        },
        {
            downloadType: 'pdf',
            downloadFileName: 'Disaster Monitoing',
            downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
            metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        },
        {
            downloadType: 'csv',
            downloadFileName: 'Disaster Monitoing',
            downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
            metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        }
    ],
    printButton: {
        display: true,
        text: 'Print',
        align: 'right',       //where to align the element within div i.e left, center or right
        order: 'order-md-2',   //Order of the element from left. defined in DataTableModule.toolBarElementOrder
        title: 'Sites'
    },
    paginatorOptions: {
        visible: true,
        limit: 10,
        maxSize: 10,
        directionLinks: 'true',
        autoHide: 'true',
        previousLabel: 'previous',
        nextLabel: 'next',
        dropdownOptions: [{
            value: 5,
            display: '5'
        },
        {
            value: 10,
            display: '10'
        },
        {
            value: 15,
            display: '15'
        },
        {
            value: 20,
            display: '20'
        },
        {
            value: 25,
            display: '25'
        },
        {
            value: -1,
            display: 'All'
        }
        ]
    },
    tableHeaderFixerInfo: {
        headerFix: true,
        colFix: true,
        rowFix: false, // If we want to fix the data rows as well.
        noOfCol: 1,
        noOfRow: 1, // no of data rows from top that needs to be fixed
        height: '500px',
        showHeight: false // If we want to set Height of table
    },
    totalRow: {
        position: 'bottom', // top, bottom
        displayAs: '', // Custom text to display, default 'Total'
        name: 'Total',
        jsonKey: '-1',
        colspan: 1, // How many columns should it span to, this will start from the far left so add +1 to make up for S.No column
        class: 'fixed-row',
        key: 'lUUID'
    },
    indexCons: {
        show: false,
        class: 'tc-bg-01',
        tooltip: 'S.No'
    },
    columns: []
}

export const BaseLevelColumnConfig = [
    {
        name: 'Location',
        jsonKey: {
            path: 'name'
        },
        class: 'tc-bg-01',
        dataType: 'LOCATION',
        defaultValue: '-'
    },
    {
        name: 'Peopele Affected',
        jsonKey: {
            path: 'affected'
        },
        class: 'tc-bg-01',
        dataType: 'TEXT',
        defaultValue: '-'
    },
    {
        name: 'People Injured',
        jsonKey: {
            path: 'injured'
        },
        class: 'tc-bg-01',
        dataType: 'TEXT',
        defaultValue: '-'
    },
    {
        name: 'Homeless',
        jsonKey: {
            path: 'homeless'
        },
        class: 'tc-bg-01',
        dataType: 'TEXT',
        defaultValue: '-'
    },
    {
        name: 'Fatalities',
        jsonKey: {
            path: 'totalDeath'
        },
        class: 'tc-bg-01',
        dataType: 'TEXT',
        defaultValue: '-'
    },
    {
        name: 'Damage (INR)',
        jsonKey: {
            path: 'totalDam'
        },
        class: 'tc-bg-01',
        dataType: 'TEXT',
        defaultValue: '-'
    },
    // {
    //     name: 'Fatalities',
    //     jsonKey: {
    //         path: 'fatalities'
    //     },
    //     class: 'tc-bg-01',
    //     dataType: 'TEXT',
    //     defaultValue: '-'
    // }
]
export const DISASTER_MONITOR_LEGEND_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
       DISASTER_LEGEND: {
            "colorValues": [
               {
                  image:'../assets/imgs/alert-icons/reservoir_danger.svg',
                  text: 'Disaster Event'
               }
            ]
        }
    }
}

export const DISASTER_TYPE_LIST: any = {
    EM_DAT: [
        { key: 'All', value: 'All' },
        { key: 'Drought', value: 'Drought' },
        { key: 'Earthquake', value: 'Earthquake' },
        { key: 'Epidemic', value: 'Epidemic' },
        { key: 'Extreme temperature', value: 'Extreme temperature' },
        { key: 'Flood', value: 'Flood' },
        { key: 'Glacial lake outburst flood', value: 'Glacial lake outburst flood' },
        { key: 'Industrial accident (General)', value: 'Industrial accident (General)' },
        { key: 'Infestation', value: 'Infestation' },
        { key: 'Mass movement (dry)', value: 'Mass movement (dry)' },
        { key: 'Mass movement (wet)', value: 'Mass movement (wet)' },
        { key: 'Storm', value: 'Storm' },
        { key: 'Water', value: 'Water' },
        { key: 'Wildfire', value: 'Wildfire' }
    ],
    WEB_AGENT: [
        { key: 'All', value: 'All' },
        { key: 'Flood', value: 'Flood' },
        { key: 'Cloud Burst', value: 'Cloud burst' },
        { key: 'Flash Flood', value: 'flash flood' },
        { key: 'Landslide', value: 'landslide' },
        { key: 'Cyclone', value: 'Cyclone' },
        { key: 'Dam break', value: 'Dam break' },
        { key: 'Zero day', value: 'no water' },
        { key: 'Heat Wave', value: 'Heat Wave' }
    ]
}

export const DISASTER_YEARLIST: any = {
    EM_DAT: [{ key: '2020', value: '2020' }, { key: '2021', value: '2021' }, { key: '2022', value: '2022' }, { key: '2023', value: '2023' }, { key: '2024', value: '2024' }, { key: '2025', value: '2025' }],
    WEB_AGENT: [{ key: '2010', value: '2010' }, { key: '2011', value: '2011' }, { key: '2012', value: '2012' }, { key: '2013', value: '2013' }, { key: '2014', value: '2014' }, { key: '2015', value: '2015' }, { key: '2016', value: '2016' }, { key: '2017', value: '2017' }, { key: '2018', value: '2018' }, { key: '2019', value: '2019' }, { key: '2020', value: '2020' }, { key: '2021', value: '2021' }, { key: '2022', value: '2022' }, { key: '2023', value: '2023' }, { key: '2024', value: '2024' }, { key: '2025', value: '2025' }]
}